'use client';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { forwardRef, useEffect, useRef, useState } from 'react';
import type { PhoneInputProps } from 'react-international-phone';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

export const PhoneInputField = forwardRef(
  ({
    className,
    variant,
    ...props
  }: PhoneInputProps & {
    variant?: 'outlined' | 'default';
  }) => {
    const [focused, setFocused] = useState(false);
    const phoneInputRef = useRef(null);

    const locale = useLocaleStore(s => s.currentLocale);

    const defaultCountryFromLocale = () => {
      if (locale === 'cs') {
        return 'cz';
      }

      return locale;
    };

    useEffect(() => {
      const handleClickOutside = (event: any) => {
        const current = phoneInputRef.current as any;

        if (current && !current.contains(event.target)) {
          setFocused(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [phoneInputRef]);

    return (
      <div
        ref={phoneInputRef}
        className={cn(
          variant === 'outlined' ? 'bg-white' : 'border-none',
          className,
        )}
      >
        <PhoneInput
          defaultCountry={defaultCountryFromLocale()}
          name="phone"
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          inputClassName={cn('bg-white')}
          inputStyle={{
            backgroundColor: 'bg-white',
            height: '48px',
            paddingLeft: '12px',
            width: '100%',
            borderRadius: '0px',
            border: '1px solid #acbed1',
          }}
          countrySelectorStyleProps={{
            buttonClassName: 'bg-white',
            buttonStyle: {
              height: '48px',
              backgroundColor: 'bg-white',
              borderStartStartRadius: 'none',
              borderEndStartRadius: 'none',
              paddingLeft: '24px',
              paddingRight: '24px',
              borderRadius: '0px',
              borderLeft: '1px solid #acbed1',
              borderTop: '1px solid #acbed1',
              borderBottom: '1px solid #acbed1',
              borderRight: '1px solid #acbed1',
            },
          }}
          {...props}
        />
      </div>
    );
  },
);

PhoneInputField.displayName = 'PhoneInputField';
